import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'

export const introducerApprovalResolver = yupResolver(
  yup.object().shape({
    introducerCommission: yup
      .number()
      .min(0)
      .required('Commission field is required')
      .typeError('Value must be a number type'),
    introducerBankFee: yup
      .number()
      .min(0)
      .required('Bank fees field is required')
      .typeError('Value must be a number type'),
    introducerLiquidityFee: yup
      .number()
      .min(0)
      .required('Liquidity fees is required')
      .typeError('Value must be a number type'),
  }),
)

export const introducerRejectResolver = yupResolver(
  yup.object().shape({
    introducerRejectionReason: yup
      .string()
      .required('Decline reason field is required')
      .max(255, 'Reason must be at most 255 characters'),
  }),
)

export const introducerSuspendResolver = yupResolver(
  yup.object().shape({
    introducerSuspensionReason: yup
      .string()
      .required('Suspension reason field is required')
      .max(255, 'Reason must be at most 255 characters'),
  }),
)

export const introducerAssignResolver = yupResolver(
  yup.object().shape({
    assignUser: yup.string().required('Assign user field is required'),
  }),
)

export const introducerReassignResolver = yupResolver(
  yup.object().shape({
    reassignUser: yup.string().required('Reassign user field is required'),
  }),
)
